<page-title [title]="title"></page-title>
<p align="center">Cuidar da sua saúde é fundamental, agende um atendimento com a Secretarias :)</p>
<div class="col-xs-6 col-md-3 col-md-offset-3">
    <mat-toolbar color="primary" class="center-card" (click)="goToUrl('agendar/consulta')">
        <mat-toolbar-row><mat-icon>local_hospital</mat-icon></mat-toolbar-row>
        <mat-toolbar-row>Agendar</mat-toolbar-row>
        <mat-toolbar-row>consulta</mat-toolbar-row>
    </mat-toolbar>
</div>
<div class="col-xs-6 col-md-3">
    <mat-toolbar color="primary" class="center-card" (click)="goToUrl('agendar/exame')">
        <mat-toolbar-row><mat-icon>monitor_heart</mat-icon></mat-toolbar-row>
        <mat-toolbar-row>Agendar</mat-toolbar-row>
        <mat-toolbar-row>serviço</mat-toolbar-row>
    </mat-toolbar>
</div>
